import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Areas';

export interface Area {
	idDN: string;
	direccionNegocio: string;
  codArea: string;
	area: string;
	funcionesSubFunciones: any;
}

export class AreasAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarAreas(): AxiosPromise<Area[]> {
		return this.cliente.get(`/ListarAreas`);
	}

	ListarAreasDN(idDN:any): AxiosPromise<Area[]> {
		return this.cliente.get(`/ListarAreas/${idDN}`);
	}

	ListarAreasPermisos(idDN:any): AxiosPromise<Area[]> {
		return this.cliente.get(`/ListarAreasPermisos/${idDN}`);
	}

	CrearArea(area:any): AxiosPromise<any[]> {
		return this.cliente.post(area,`/CrearArea`);
	}
	
	EliminarArea(id: string): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarArea`);
	}

	ModificarArea(area: any): AxiosPromise<any[]> {
		return this.cliente.put(area.idArea, area, `/ModificarArea`);
	}
}